/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiUserFeedbackControllerDeleteMutationResponse, AiUserFeedbackControllerDeletePathParams, AiUserFeedbackControllerDelete401, AiUserFeedbackControllerDelete404 } from "../../models/aiUserFeedbackController/AiUserFeedbackControllerDelete";

function getAiUserFeedbackControllerDeleteUrl(id: AiUserFeedbackControllerDeletePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/ai-user-feedback/${id}` as const }  
  return res
}

/**
 * @summary Delete feedback (soft delete)
 * {@link /api/v1/ai-user-feedback/:id}
 */
export async function aiUserFeedbackControllerDelete(id: AiUserFeedbackControllerDeletePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiUserFeedbackControllerDeleteMutationResponse, ResponseErrorConfig<AiUserFeedbackControllerDelete401 | AiUserFeedbackControllerDelete404>, unknown>({ method : "DELETE", url : getAiUserFeedbackControllerDeleteUrl(id).url.toString(), ... requestConfig })  
  return res.data
}